/* eslint-disable default-param-last */
import {
  SET_LOADING,
  SET_ERROR,
  SET_OK,
  SET_RESET,
  SET_SEARCH,
  SET_USERNAME,
  USER_LOGGED_OUT,
  SET_ADD,
  SET_SERVER_NAME,
  SET_CLIENT_ID,
  SET_CLIENTS,
  SET_COPY,
  SET_MODAL_BRAND,
  SET_MENU_SELECT,
  SET_WARNING,
  SET_SELECTED_CLIENT,
} from '../types'

export function loading(state = false, action) {
  switch (action.type) {
    case SET_LOADING:
      return action.show
    default:
      return state
  }
}

export function error(state = '', action) {
  switch (action.type) {
    case SET_ERROR:
      return action.text
    default:
      return state
  }
}

export function warning(state = '', action) {
  switch (action.type) {
    case SET_WARNING:
      return action.text
    default:
      return state
  }
}

export function ok(state = false, action) {
  switch (action.type) {
    case SET_OK:
      return action.value
    default:
      return state
  }
}

export function copy(state = false, action) {
  switch (action.type) {
    case SET_COPY:
      return action.value
    default:
      return state
  }
}

export function search(state = false, action) {
  switch (action.type) {
    case SET_SEARCH:
      return action.value
    default:
      return state
  }
}

export function reset(state = false, action) {
  switch (action.type) {
    case SET_RESET:
      return action.show
    default:
      return state
  }
}

export function user(state = '', action) {
  switch (action.type) {
    case SET_USERNAME:
      return action.username
    case USER_LOGGED_OUT:
      return ''
    default:
      return state
  }
}

export function add(state = '', action) {
  switch (action.type) {
    case SET_ADD:
      return action.url
    default:
      return state
  }
}

export function servername(state = '', action) {
  const activeClient_stringify = localStorage.getItem('activeLateralBar_client')
  const activeClient_parsed = activeClient_stringify ? JSON.parse(activeClient_stringify) : null
  const activeClient_parsed_id = (activeClient_parsed && activeClient_parsed.clientId)
    ? parseInt(activeClient_parsed.clientId, 10)
    : null
  switch (action.type) {
    case SET_SERVER_NAME:
      return action.value
    case SET_CLIENTS:
      if (action?.response?.clients && action?.response?.clients.length > 0) {
        if (activeClient_parsed_id) {
          const selected_client = action?.response?.clients.filter((client) => client.id === activeClient_parsed_id)
          return (selected_client.length > 0 && selected_client[0]?.name)
            ? selected_client[0]?.name
            : action?.response?.clients[0]?.name
        }
        return action?.response?.clients[0]?.name
      } return state
    default:
      return state
  }
}

export function clientid(state = '', action) {
  const activeClient_stringify = localStorage.getItem('activeLateralBar_client')
  const activeClient_parsed = activeClient_stringify ? JSON.parse(activeClient_stringify) : null
  const activeClient_parsed_id = (activeClient_parsed && activeClient_parsed.clientId)
    ? parseInt(activeClient_parsed.clientId, 10)
    : null
  switch (action.type) {
    case SET_CLIENT_ID:
      return action.clientid
    case SET_CLIENTS:
      if (action?.response?.clients && action?.response?.clients.length > 0) {
        if (activeClient_parsed_id) {
          const selected_client = action?.response?.clients.filter((client) => client.id === activeClient_parsed_id)
          return (selected_client.length > 0 && selected_client[0]?.id)
            ? selected_client[0]?.id
            : action.response.clients[0]?.id
        }
        return action.response.clients[0]?.id
      } return state
    default:
      return state
  }
}

export function selectedClient(state = null, action) {
  switch (action.type) {
    case SET_SELECTED_CLIENT:
      return action.selectedClient
    default:
      return state
  }
}

export function modalBrand(state = false, action) {
  switch (action.type) {
    case SET_MODAL_BRAND:
      return action.value
    default:
      return state
  }
}

export function setMenuItem(state = '', action) {
  switch (action.type) {
    case SET_MENU_SELECT:
      return action.value
    default:
      return state
  }
}
